import React from "react";
import { useMemo } from "react";
import { Tooltip } from "antd";
import { numberRound, returnEuroString } from "../../../../../../helpers/Utils";
import { IconDot } from "../../../../../Layout/Icons";
import { CheckBoxInput } from "../../../../Buttons";

export default function MoneyRefundOrderCartRulesPreview({
  type = "basic",
  order_cart_rules,
  setValue,
  order_cart_rules_selected,
}) {
  if (!Array.isArray(order_cart_rules)) return null;

  const texts = useMemo(() => {
    return {
      tooltip_text:
        type == "basic"
          ? ""
          : type == "success"
            ? "Sent to bank"
            : "Not sent to bank",
      container_class:
        type == "basic"
          ? "bg-light-primary"
          : type == "success"
            ? "bg-green-light"
            : "bg-red-light",
      text_class: type == "success" ? "text-info" : "text-danger",
    };
  }, [type]);

  return (
    <div className={`${texts.container_class} rounded`}>
      {order_cart_rules.map(({ id, title, total }, idx) => (
        <div
          key={id}
          className={`${setValue ? "cursor-pointer" : ""} px-3 py-2`}
          onClick={
            setValue
              ? () => {
                const current = order_cart_rules_selected || [];
                const or = current.includes(id)
                  ? current.filter((e) => e !== id)
                  : [...current, id];
                const sum = numberRound(order_cart_rules
                  .filter((d) => or.includes(d.id))
                  .reduce(
                    (total, cur) =>
                      +cur.total +
                      total,
                    0
                  ))

                setValue({
                  order_cart_rules: or,
                  sum,
                });
              }
              : null
          }
        >
          <div
            className="d-flex justify-content-between align-items-center pb-2"
            style={{
              borderBottom: `1px solid ${order_cart_rules.length - 1 == idx ? "transparent" : "#D4E8FB"
                }`,
            }}
          >
            <div className="d-flex align-items-center text-sm">
              {setValue && type == "basic" && (
                <CheckBoxInput checked={order_cart_rules_selected.includes(id)} />
              )}
              {type !== "basic" && (
                <Tooltip placement="left" title={texts.tooltip_text}>
                  <IconDot className={texts.text_class} />
                </Tooltip>
              )}
              <div
                className="d-flex flex-column ml-3"
                style={{
                  lineHeight: "16px",
                }}
              >
                {title}
              </div>
            </div>
            <div>{returnEuroString(total)}</div>
          </div>

        </div>
      ))
      }
    </div >
  );
}
